var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Log de Erros")]),_c('div',{staticClass:"caixa"},_vm._l((_vm.mensagens),function(mensagen,idx){return _c('div',{key:idx},[_vm._v(" "+_vm._s(mensagen)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }